import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(theme => ({
  card: {
    border: '1px solid #E0E0E0',
    borderRadius: 12,
    backgroundColor: '#FFFFFF',
    overflow: 'hidden',
  },
  banner: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1.5),
    padding: theme.spacing(1.5, 2),
    fontSize: '0.875rem',
    lineHeight: 1.4,
    color: '#172024',
    borderRadius: 12,
  },
  bannerInfo: {
    backgroundColor: '#E0EAFF',
    border: '1px solid #C5D4FF',
  },
  bannerWarning: {
    backgroundColor: '#FFF8E1',
    border: '1px solid #FFE082',
  },
  bannerError: {
    backgroundColor: '#FFEBEE',
    border: '1px solid #FFCDD2',
  },
  bannerIconInfo: {
    color: '#0053FF',
    fontSize: 20,
    flexShrink: 0,
  },
  bannerIconWarning: {
    color: '#FF9800',
    fontSize: 20,
    flexShrink: 0,
  },
  bannerIconError: {
    color: '#D32F2F',
    fontSize: 20,
    flexShrink: 0,
  },
  bannerLink: {
    fontWeight: 600,
    color: 'inherit',
  },
  cardBody: {
    padding: theme.spacing(3),
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(3),
    [theme.breakpoints.down('xs')]: {
      padding: theme.spacing(2),
      gap: theme.spacing(2),
    },
  },
  profileHeader: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: theme.spacing(2.5),
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      alignItems: 'center',
      textAlign: 'center',
    },
  },
  avatarWrapper: {
    flexShrink: 0,
  },
  avatar: {
    width: 80,
    height: 80,
    fontSize: '1.5rem',
    fontWeight: 500,
    color: '#00205B',
    backgroundColor: '#E8F1FF',
    textTransform: 'uppercase',
  },
  profileDetails: {
    flex: '1 1 auto',
    minWidth: 0,
    paddingTop: theme.spacing(0.5),
  },
  nameRow: {
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
    gap: theme.spacing(1),
    marginBottom: theme.spacing(1),
    [theme.breakpoints.down('sm')]: {
      justifyContent: 'center',
    },
  },
  name: {
    fontWeight: 700,
    fontSize: '1.25rem',
    lineHeight: 1.3,
    color: '#00205B',
  },
  statusBadge: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: 20,
    padding: '0 8px',
    borderRadius: 8,
    fontSize: '0.625rem',
    fontWeight: 500,
    letterSpacing: '0.02em',
    lineHeight: 1,
    whiteSpace: 'nowrap',
  },
  promotionStatusPromoted: {
    color: '#00210B',
    backgroundColor: '#BEF1BB',
  },
  promotionStatusWarning: {
    color: '#8A6D1D',
    backgroundColor: '#FFF8E1',
  },
  promotionStatusInactive: {
    color: '#C62828',
    backgroundColor: '#FFEBEE',
  },
  locationRow: {
    display: 'flex',
    alignItems: 'center',
    gap: 4,
    color: theme.palette.text.secondary,
    fontSize: '0.875rem',
    lineHeight: 1.4,
    [theme.breakpoints.down('sm')]: {
      justifyContent: 'center',
    },
  },
  locationIcon: {
    fontSize: 16,
    color: theme.palette.text.secondary,
  },
  profileTrailing: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-end',
    gap: theme.spacing(1.5),
    flexShrink: 0,
    marginLeft: 'auto',
    [theme.breakpoints.down('sm')]: {
      alignItems: 'center',
      marginLeft: 0,
      width: '100%',
    },
  },
  profileActions: {
    gap: theme.spacing(1),
    justifyContent: 'flex-start',
    marginTop: theme.spacing(2.5),
    [theme.breakpoints.down('sm')]: {
      justifyContent: 'center',
    },
  },
  qrColumn: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    flexShrink: 0,
    [theme.breakpoints.down('sm')]: {
      marginLeft: 0,
    },
  },
  qrCode: {
    border: '1px solid #E0E0E0',
    borderRadius: 8,
    padding: 8,
    marginBottom: 4,
  },
  qrDownload: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 4,
    color: theme.palette.text.secondary,
    fontSize: '0.75rem',
    textTransform: 'none',
    minWidth: 0,
    padding: theme.spacing(0.5),
    '& .MuiSvgIcon-root': {
      fontSize: 16,
    },
  },
  visibilitySection: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: theme.spacing(2),
    padding: theme.spacing(2, 2.5),
    borderRadius: 12,
    backgroundColor: '#F4F7F9',
    [theme.breakpoints.down('xs')]: {
      flexDirection: 'column',
      alignItems: 'flex-start',
    },
  },
  visibilityCopy: {
    minWidth: 0,
  },
  visibilityTitle: {
    fontWeight: 700,
    fontSize: '0.9375rem',
    lineHeight: 1.3,
    color: theme.palette.text.primary,
    marginBottom: 4,
  },
  visibilityCaption: {
    fontSize: '0.8125rem',
    lineHeight: 1.4,
    color: theme.palette.text.secondary,
  },
  visibilitySwitch: {
    margin: 0,
    flexShrink: 0,
  },
  performanceHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  performanceTitle: {
    fontWeight: 700,
    fontSize: '1rem',
    lineHeight: 1.3,
    color: '#172024',
  },
  periodButton: {
    height: 40,
    borderRadius: 8,
    fontWeight: 500,
    flexShrink: 0,
    borderColor: '#C4C7C9',
    color: '#172024',
    textTransform: 'none',
    '& .MuiButton-endIcon': {
      color: '#6B7C87',
    },
  },
  periodMenu: {
    marginTop: theme.spacing(0.5),
    borderRadius: 8,
    border: '1px solid #E0E0E0',
    minWidth: 140,
    boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.08)',
  },
  metricsGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(3, minmax(0, 1fr))',
    gap: theme.spacing(1.5),
    [theme.breakpoints.down('sm')]: {
      gridTemplateColumns: '1fr',
      gap: theme.spacing(1.5),
    },
  },
  metricCard: {
    border: '1px solid #E0E0E0',
    borderRadius: 12,
    padding: theme.spacing(2.5, 2),
    backgroundColor: '#FFFFFF',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    textAlign: 'left',
  },
  metricLabel: {
    fontSize: '0.6875rem',
    fontWeight: 500,
    letterSpacing: '0.08em',
    lineHeight: 1.3,
    textTransform: 'uppercase',
    color: '#6B7C87',
    marginBottom: theme.spacing(1.25),
  },
  metricValue: {
    fontSize: '2rem',
    fontWeight: 700,
    lineHeight: 1,
    color: '#00205B',
    marginBottom: theme.spacing(1.25),
  },
  metricChangePositive: {
    color: '#00210B',
    backgroundColor: '#BEF1BB',
  },
  metricChangeNeutral: {
    color: '#6B7C87',
    backgroundColor: '#ECEFF1',
  },
  metricChangeNegative: {
    color: '#C62828',
    backgroundColor: '#FFEBEE',
  },
  coachPlusSection: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: theme.spacing(2.5),
    padding: theme.spacing(3),
    backgroundColor: '#E0EAFF',
    border: '1px solid #C5D4FF',
    borderRadius: 12,
    [theme.breakpoints.down('xs')]: {
      flexDirection: 'column',
      alignItems: 'flex-start',
    },
  },
  coachPlusCopy: {
    minWidth: 0,
    flex: 1,
  },
  coachPlusTitle: {
    fontWeight: 700,
    fontSize: '1.125rem',
    lineHeight: 1.3,
    color: '#00205B',
    marginBottom: theme.spacing(0.75),
  },
  coachPlusDetail: {
    fontSize: '0.875rem',
    lineHeight: 1.5,
    color: '#172024',
    margin: 0,
  },
  coachPlusButton: {
    borderRadius: 20,
    textTransform: 'none',
    fontWeight: 700,
    fontSize: '0.9375rem',
    padding: theme.spacing(1.25, 3.5),
    whiteSpace: 'nowrap',
    flexShrink: 0,
    boxShadow: 'none',
    '&:hover': {
      boxShadow: '0 4px 12px rgba(0, 83, 255, 0.28)',
    },
  },
  loading: {
    margin: theme.spacing(3),
  },
}))

export default useStyles
